import { render } from "./HeroiconsOutlineArrowNarrowDown.vue?vue&type=template&id=7d140d7e"
const script = {}

import exportComponent from "E:\\Work\\wynajmy\\nova\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"HeroiconsOutlineArrowNarrowDown.vue"]])

export default __exports__